import { render, staticRenderFns } from "./veStuGraduationXuhaoEdit.vue?vue&type=template&id=6f471db5&scoped=true"
import script from "./veStuGraduationXuhaoEdit.vue?vue&type=script&lang=js"
export * from "./veStuGraduationXuhaoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f471db5",
  null
  
)

export default component.exports